import type { PropsWithChildren } from 'react';

interface ContainerProps {
    className?: string;
    id?: string;
}

export default function Container({ children, className = '', id }: PropsWithChildren<ContainerProps>) {
    return (
        <div id={id} className={`relative w-full max-w-full overflow-hidden ${className}`} style={{ height: '100dvh' }}>
            {children}
        </div>
    );
}
